import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { WebhooksLogoIcon } from "@phosphor-icons/react";
import { fetchGrokWebhooks, createGrokWebhook, deleteGrokWebhook } from "../../lib/api";
import { Input } from "../ui-bits";

export function WebhooksPanel() {
  const [hooks, setHooks] = useState([]);
  const [url, setUrl] = useState("");
  const [secret, setSecret] = useState(null);

  const load = useCallback(async () => {
    try { setHooks(await fetchGrokWebhooks()); } catch { /* empty */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    try { const h = await createGrokWebhook({ url: url.trim() }); setSecret(h.secret); setUrl(""); await load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not add webhook"); }
  };
  const remove = async (id) => {
    try { await deleteGrokWebhook(id); setSecret(null); toast.success("Webhook deleted"); await load(); } catch { toast.error("Could not delete"); }
  };

  return (
    <div className="border border-zinc-200 bg-white p-5" data-testid="grok-webhooks-panel">
      <div className="overline mb-1 flex items-center gap-1.5"><WebhooksLogoIcon size={13} weight="bold" /> Events to Grok</div>
      <div className="font-heading font-black text-lg mb-3">Webhooks</div>
      <div className="flex gap-2 mb-3">
        <Input data-testid="grok-webhook-url-input" placeholder="https://…" value={url} onChange={(e) => setUrl(e.target.value)} className="flex-1" />
        <button data-testid="grok-webhook-add-btn" onClick={add} disabled={!url.trim()} className="px-4 py-2 text-xs font-bold uppercase tracking-wider bg-zinc-950 text-white hover:bg-zinc-800 disabled:opacity-40">Add</button>
      </div>
      {secret && (
        <div className="text-xs border-2 border-zinc-950 p-2.5 mb-3 break-all" data-testid="grok-webhook-secret">
          Signing secret (shown once, verify <code>X-Grok-Signature</code>): <code className="font-mono-num">{secret}</code>
        </div>
      )}
      <div className="divide-y divide-zinc-100">
        {hooks.map((h) => (
          <div key={h.id} data-testid={`grok-webhook-row-${h.id}`} className="py-2.5 text-sm flex items-center gap-3">
            <div className="flex-1 min-w-0">
              <div className="truncate font-medium">{h.url}</div>
              <div className="text-[11px] text-zinc-400">{h.events.length} events · last: {h.last_delivery ? `${h.last_delivery.status_code || "error"} ${h.last_delivery.event}` : "none yet"}</div>
            </div>
            <button data-testid={`grok-webhook-delete-${h.id}`} onClick={() => remove(h.id)} className="text-xs font-semibold text-[#FF3B30] hover:underline">Delete</button>
          </div>
        ))}
        {hooks.length === 0 && <div className="text-sm text-zinc-400 py-4 text-center">No webhooks — events are logged but not sent anywhere.</div>}
      </div>
    </div>
  );
}
